<script setup lang="ts">
const props = defineProps<{
  active: boolean
}>()
</script>

<template>
  <button
    class="h-3.4rem w-3.4rem flex items-center justify-center overflow-hidden focus rounded-full bg-starline-secondary transition duration-500 hover:focusActive"
    :class="props.active ? 'focusActive' : ''"
  >
    <slot />
  </button>
</template>

<style scoped>

</style>
